<template>
  <v-container fluid>
    <main-header-plat-a />
    <main-header-plat-b :navBItems="schema.navBItems" />
    <v-overlay-loader :status="effectiveStatus" />
    <v-container class="mt-2">
      <v-card>
        <v-row class="fill-height">
          <v-col cols="12">
            <v-sheet :height="$vuetify.breakpoint.xs ? '120' : '64'">
              <v-toolbar flat class="flex-wrap" :height="$vuetify.breakpoint.xs ? '120' : '64'">
                <v-row class="fill-height">
                  <v-col cols="12" sm="9" class="d-flex justify-start pb-0 pb-sm-2">
                    <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday"> Hoy </v-btn>
                    <v-btn fab text small color="grey darken-2" @click="prev">
                      <v-icon small> mdi-chevron-left </v-icon>
                    </v-btn>
                    <v-btn fab text small color="grey darken-2" @click="next">
                      <v-icon small> mdi-chevron-right </v-icon>
                    </v-btn>
                    <v-toolbar-title v-if="$refs.calendar">
                      {{ $refs.calendar.title }}
                    </v-toolbar-title>
                  </v-col>

                  <v-col cols="12" sm="3" class="d-flex justify-end">
                    <v-btn
                      color="primary"
                      dark
                      class="mr-4 text-capitalize"
                      @click="(dialog = true), cleanName()"
                    > Nuevo </v-btn>
                    <v-dialog v-model="dialog" width="600px">
                      <v-card>
                        <v-container>
                          <v-form @submit.prevent="addEvent" class="mx-7 my-2 pb-0 pb-sm-1">
                            <v-row class="mt-16">
                              <v-col cols="12" sm="6" class="mt-9 mt-sm-0 pb-0 pb-sm-1">
                                <v-select
                                  v-model="name"
                                  label="Tipo de Evento"
                                  :items="typeEventGroup"
                                  outlined
                                  dense
                                  hide-details
                                  persistent-placeholder
                                >
                                </v-select>
                              </v-col>
                              <v-col cols="12" sm="6" class="pb-1 pb-sm-1">
                                <v-select
                                  outlined
                                  dense
                                  hide-details
                                  persistent-placeholder
                                  label="Color del evento"
                                  :items="colors"
                                  v-model="color"
                                >
                                </v-select>
                              </v-col>
                              <v-col cols="12" class="pb-0 pb-sm-1">
                                <v-textarea
                                  outlined
                                  dense
                                  hide-details
                                  persistent-placeholder
                                  rows="1"
                                  auto-grow
                                  type="text"
                                  label="Descripción"
                                  v-model="details"
                                >
                                </v-textarea>
                              </v-col>
                              <v-col cols="5" sm="3" class="pb-0" v-if="isSessionOrBusy">
                                <v-text-field
                                  outlined
                                  dense
                                  hide-details
                                  persistent-placeholder
                                  type="text"
                                  label="N° Paciente"
                                  v-model="nPat"
                                >
                                </v-text-field>
                              </v-col>
                              <v-col cols="7" sm="9" class="pb-0" v-if="isSessionOrBusy">
                                <v-text-field
                                  outlined
                                  dense
                                  hide-details
                                  persistent-placeholder
                                  class="text-caption"
                                  label="NPat Completo"
                                  v-model="patientNameAbrev"
                                >
                                </v-text-field>
                              </v-col>
                              <v-col cols="10" sm="5" class="mt-0 mt-sm-4 pb-0 pb-sm-1">
                                <v-text-field
                                  type="datetime-local"
                                  label="Fecha de Inicio"
                                  v-model="start"
                                  outlined
                                  dense
                                  hide-details
                                >
                                </v-text-field>
                              </v-col>
                              <v-col cols="1" sm="2" class="mt-0 mt-sm-4 pb-0 pb-sm-1">
                                <v-spacer></v-spacer>
                              </v-col>
                              <v-col cols="10" sm="5" class="mt-0 mt-sm-4 pb-0 pb-sm-1">
                                <v-text-field
                                  type="datetime-local"
                                  label="Fecha de Fin"
                                  v-model="end"
                                  outlined
                                  dense
                                  hide-details
                                >
                                </v-text-field>
                              </v-col>
                              <v-col cols="12">
                                <v-textarea
                                  outlined
                                  dense
                                  hide-details
                                  persistent-placeholder
                                  rows="1"
                                  auto-grow
                                  type="text"
                                  label="Observaciones"
                                  v-model="observations"
                                >
                                </v-textarea>
                              </v-col>
                            </v-row>
                            <v-row class="mt-2">
                              <v-col cols="3" class="py-0 py-sm-1">
                                <v-btn
                                  text
                                  dark
                                  large
                                  class="d-flex primary--text text-caption"
                                  @click="cleanForm"
                                >
                                  Limpiar
                                </v-btn>
                              </v-col>
                              <v-col cols="3" sm="6" class="py-0 py-sm-1">
                                <v-spacer></v-spacer>
                              </v-col>
                              <v-col cols="3" class="py-0 py-sm-1">
                                <v-btn type="submit" color="primary" @click.stop="dialog = false">
                                  Agregar
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-form>
                        </v-container>
                      </v-card>
                    </v-dialog>
                  
                    <v-menu bottom right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                          <span>{{ typeToLabel[type] }}</span>
                          <v-icon right> mdi-menu-down </v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="type = 'day'">
                          <v-list-item-title>Dia</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="type = 'week'">
                          <v-list-item-title>Semana</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="type = 'month'">
                          <v-list-item-title>Mes</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="type = '4day'">
                          <v-list-item-title>4 dias</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-toolbar>
            </v-sheet>
            <v-sheet height="1060">
              <v-calendar
                ref="calendar"
                v-model="focus"
                color="primary"
                :events="allCombinedAndFilteredEvents"
                :event-color="getEventColor"
                :type="type"
                @click:event="showEvent"
                @click:more="viewDay"
                @click:date="viewDay"
                @change="updateRange"
                first-time="04:00"
                :interval-count="20"
              >
                <template v-slot:event="{ event, timeSummary }">
                  <div class="px-1 text-truncate" style="line-height: 1.2; font-size: 11px;">
                    <b>{{ event.name }}</b>
                    
                    <!-- Se agregan los paréntesis para invocar la función de Vuetify -->
                    <span v-if="timeSummary">, {{ timeSummary() }}</span>
                    <span v-if="event.patientNameAbrev">, Pac. {{ event.patientNameAbrev }}</span>
                    <span v-if="event.details">, {{ event.details }}</span>
                  </div>
                </template>
              </v-calendar>
              <v-menu
                v-model="selectedOpen"
                :close-on-content-click="false"
                :activator="selectedElement"
                offset-x
                min-width="550px"
              >
                <v-card color="grey lighten-4" width="550px" flat>
                  <v-toolbar :color="selectedEvent.color" dark>
                    <span class="text-h6 ml-2">{{selectedEvent.name}}</span>
                  </v-toolbar>

                  <v-card-text>
                    <v-form v-if="currentlyEditing !== selectedEvent.id" class="ml-4">
                      
                      <p v-if="selectedEvent.name?.includes('Sesión')">
                        <b>Paciente:</b> {{ selectedEvent.patientNameAbrev }} -- [ 00{{
                          selectedEvent.nPat
                        }}
                        ]
                      </p>
                      <p><b>Horario:</b> {{ selectedEvent.start ? selectedEvent.start.replace('T', ' ').substring(11, 16) : '' }} - {{ selectedEvent.end ? selectedEvent.end.replace('T', ' ').substring(11, 16) : '' }}</p>
                      <p><b>Detalle del Evento:</b> {{ selectedEvent.details }}</p>
                      <p><b>Observaciones:</b> {{ selectedEvent.observations }}</p>
                    </v-form>

                    <v-form v-else>
                      <v-row class="mx-3 my-3">
                        <v-col cols="12" sm="6" class="mt-3">
                          <v-select
                            v-model="selectedEvent.name"
                            label="Tipo de Evento"
                            :items="typeEventGroup"
                            hide-details
                            dense
                          >
                          </v-select>
                        </v-col>
                        <v-col cols="12" sm="6" class="mt-3 pb-1">
                          <v-select
                            hide-details
                            dense
                            label="Color del evento"
                            :items="colors"
                            v-model="selectedEvent.color"
                          >
                          </v-select>
                        </v-col>
                        <v-col cols="12" class="mt-3">
                          <v-textarea
                            hide-details
                            dense
                            rows="1"
                            auto-grow
                            type="text"
                            label="Descripción"
                            v-model="selectedEvent.details"
                          >
                          </v-textarea>
                        </v-col>
                        <v-col
                          cols="3"
                          class="mt-3 pb-0"
                          v-if="this.selectedEvent.name?.includes('Sesión')"
                        >
                          <v-text-field
                            hide-details
                            dense
                            type="text"
                            label="N° Paciente"
                            v-model="selectedEvent.nPat"
                            @input="onNPatInput"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col
                          cols="12" sm="9"
                          class="mt-3 pb-0"
                          v-if="this.selectedEvent.name?.includes('Sesión')"
                        >
                          <v-text-field
                            hide-details
                            dense
                            readonly
                            class="text-caption"
                            label="NPat Completo"
                            v-model="selectedEvent.patientNameAbrev"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="5" class="mt-6">
                          <v-text-field
                            type="datetime-local"
                            label="Fecha de Inicio"
                            v-model="selectedEvent.start"
                            hide-details
                            dense
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2" class="mt-6">
                          <v-spacer></v-spacer>
                        </v-col>
                        <v-col cols="12" sm="5" class="mt-6">
                          <v-text-field
                            type="datetime-local"
                            label="Fecha de Fin"
                            v-model="selectedEvent.end"
                            hide-details
                            dense
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" class="mt-3">
                          <v-textarea
                            hide-details
                            dense
                            rows="1"
                            auto-grow
                            type="text"
                            label="Observaciones"
                            v-model="selectedEvent.observations"
                          >
                          </v-textarea>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>

                  <v-card-actions>
                    <v-btn
                      text
                      color="secondary"
                      @click="(selectedOpen = false), (currentlyEditing = null)"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      v-if="currentlyEditing !== selectedEvent.id"
                      @click.prevent="editEvent(selectedEvent.id)"
                    >
                      Editar
                    </v-btn>
                    <v-btn text v-else @click.prevent="updateEvent(selectedEvent)">
                      Guardar Cambios
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogDel = true">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                    <v-dialog v-model="dialogDel" persistent max-width="290">
                      <v-card>
                        <v-card-title class="text-h5"> Eliminar Evento </v-card-title>
                        <v-card-text>¿Estas seguro que deseas eliminar este evento?</v-card-text>
                        <v-card-actions>
                          <v-btn
                            text
                            color="red"
                            @click="deleteEvent(selectedEvent), (dialogDel = false)"
                          >
                            Eliminar
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="dialogDel = false"> Cancelar </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </v-sheet>
          </v-col>
          <v-col cols="12" sm="12" md="9" class="d-flex justify-start py-0">
            <v-checkbox 
              class="py-0"
              v-model="patternCheckboxAll"
              :label="`Disponibles:`"
              hide-details="auto"
            ></v-checkbox>
            <v-checkbox 
              class="ml-6 py-0"
              v-model="patternCheckboxPR"
              :label="`Presencial`"
              hide-details="auto"
            ></v-checkbox>
            <v-checkbox 
              class="ml-6 py-0"
              v-model="patternCheckboxON"
              :label="`Online`"
              hide-details="auto"
            ></v-checkbox>
            <v-checkbox 
              class="ml-6 py-0"
              v-model="patternCheckboxAD"
              :label="`A Domicilio`"
              hide-details="auto"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="12" md="3" class="d-flex justify-end align-end py-0">
            <!-- El botón ahora sí llama a openAvailabilityModal -->
            <v-btn
              small
              color="primary"
              class="d-flex justify-end text-caption"
              @click="openAvailabilityModal"
            >
              Ver Disponibilidad
            </v-btn>

            <!-- Ventana Modal de Vuetify (se encarga sola de oscurecer el fondo y centrarse) -->
            <v-dialog v-model="showModal" max-width="500px">
              <v-card>
                <v-card-title class="text-h5 pb-2">
                  Horarios Disponibles
                </v-card-title>
                
                <v-card-text>
                  <!-- Caja de texto estilo Vuetify -->
                  <v-textarea
                    v-model="generatedText"
                    readonly
                    outlined
                    hide-details
                    rows="12"
                  ></v-textarea>
                </v-card-text>

                <v-card-actions class="pt-0">
                  <v-spacer></v-spacer> <!-- Empuja los botones a la derecha -->
                  <v-btn color="grey darken-1" text @click="showModal = false">
                    Cerrar
                  </v-btn>
                  <v-btn color="success" depressed @click="copyText">
                    {{ copyButtonText }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
        <v-row class="ml-4">
          <v-col cols="12" class="mt-5 pb-0">
            <v-divider class="my-3"></v-divider>
            <span>DISPONIBILIDAD DE CONSULTORIOS</span>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="4">
            <span>LOCAL 1: "Presencia Consultorios" - 303</span>
            <v-checkbox class="hide-details mt-3 mb-0 py-0"
              v-model="local1C1Checkbox"
              :label="`Consultorio 1 (Básico)`"
              hide-details="auto"
            ></v-checkbox>
            <v-checkbox class="my-0 py-0"
              v-model="local1C2Checkbox"
              :label="`Consultorio 2 (Básico)`"
              hide-details="auto"
            ></v-checkbox>
            <v-checkbox class="my-0 py-0"
              v-model="local1C3Checkbox"
              :label="`Consultorio 3 (Plus)`"
              hide-details="auto"
            ></v-checkbox>
            <v-checkbox class="my-0 py-0"
              v-model="local1C4Checkbox"
              :label="`Consultorio 4 (Plus)`"
              hide-details="auto"
            ></v-checkbox>
            <v-checkbox class="my-0 py-0"
              v-model="local1AllCheckbox"
              :label="`Todo`"
              hide-details="auto"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="4">
            <span>LOCAL 2: "Presencia Consultorios" - 401 </span> <span class="text-caption">[PRONTO]</span>
            <v-checkbox class="hide-details mt-3 mb-0 py-0"
              v-model="local2C2Checkbox"
              :label="`Consultorio 2 (Básico)`"
              hide-details="auto"
              disabled
            ></v-checkbox>
            <v-checkbox class="my-0 py-0"
              v-model="local2C3Checkbox"
              :label="`Consultorio 3 (Básico)`"
              hide-details="auto"
              disabled
            ></v-checkbox>
            <v-checkbox class="my-0 py-0"
              v-model="local2C4Checkbox"
              :label="`Consultorio 4 (Plus)`"
              hide-details="auto"
              disabled
            ></v-checkbox>
            <v-checkbox class="my-0 py-0"
              v-model="local2AllCheckbox"
              :label="`Todo`"
              hide-details="auto"
              disabled
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row class="ml-1 mt-3">
          <v-col cols="12">
            <v-divider class="my-3"></v-divider>
            <v-card class="pa-4 elevation-0">
              <span>PLANTILLA DE ACTIVIDADES</span>        
              <v-data-table
                :headers="headers"
                :items="availabilityHours"
                hide-default-footer
                disable-sort
                disable-pagination
                dense
                class="elevation-1 striped-table mt-2"
              >
                <template v-slot:item.hour="{ item }">
                  <span class="font-weight-medium">{{ item.hourLabel }}</span>
                </template>

                <template
                  v-for="day in days"
                  v-slot:[`item.${day.key}`]="{ item }"
                >
                  <div class="pa-0 ma-0">
                    <v-select
                      v-model="item.availability[day.index]"
                      :items="typeEventAbbrev"
                      item-text="event_type"
                      item-value="event_type_id"
                      clearable
                      hide-details
                      density="compact"
                      variant="outlined"
                      class="px-7"
                      style="max-width: 160px;"
                    >
                      <template v-slot:selection="{ item }">
                        {{ item?.event_type_abbrev ?? '' }}
                      </template>
                    </v-select>
                  </div>
                </template>
              </v-data-table>
              
              <v-card-actions class="mt-4">
                <v-btn text color="secondary" @click="resetAvailability">Reiniciar</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="saveAvailability">
                  <v-icon left>mdi-content-save</v-icon>
                  Guardar
                </v-btn>
              </v-card-actions>
            </v-card>
            <v-divider class="my-3" vertical></v-divider>
          </v-col>
        </v-row>
      </v-card>
      <v-snack-bar :snackbar="snackbar" />
    </v-container>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderPlatA from '@/components/includes/MainHeaderPlatA.vue';
import MainHeaderPlatB from '@/components/includes/MainHeaderPlatB.vue';
import VOverlayLoader from '@/components/base/VOverlayLoader.vue';
import VSnackBar from '@/components/base/VSnackBar.vue';
import { getToken } from "@/store/utils/storeHelpers";

const DAY_KEY_MAP_INVERSE = {
  0: 'weekly_pattern_sunday',
  1: 'weekly_pattern_monday',
  2: 'weekly_pattern_tuesday',
  3: 'weekly_pattern_wednesday',
  4: 'weekly_pattern_thursday',
  5: 'weekly_pattern_friday',
  6: 'weekly_pattern_saturday',
};

const generateHours = (initialCodes = null) => {

  const codesByHour = initialCodes && Array.isArray(initialCodes)
    ? initialCodes.map(row => {
        if (!Array.isArray(row)) return Array(7).fill(null);

        const fixed = Array(7).fill(null);
        for (let d = 0; d < 7; d++) {
          fixed[d] = row[d] ?? null;
        }
        return fixed;
      })
    : Array.from({ length: HOUR_SLOTS.length }, () => Array(7).fill(null));

  const hours = [];

  HOUR_SLOTS.forEach((slot, index) => {
    const nextHour = HOUR_SLOTS[index + 1]
      ? HOUR_SLOTS[index + 1].label
      : `${slot.id + 1}:00`;

    hours.push({
      hourLabel: `${slot.label} - ${nextHour}`,
      availability: codesByHour[index] || Array(7).fill(null),
      hourIndex: index,
      rawHourId: slot.id,
    });
  });

  return hours;
};

const days = [
  { text: 'Dom', key: 'domingo', index: 0 },
  { text: 'Lun', key: 'lunes', index: 1 },
  { text: 'Mar', key: 'martes', index: 2 },
  { text: 'Mié', key: 'miercoles', index: 3 },
  { text: 'Jue', key: 'jueves', index: 4 },
  { text: 'Vie', key: 'viernes', index: 5 },
  { text: 'Sáb', key: 'sabado', index: 6 },
];

const headers = [
  { text: 'Horario', value: 'hour', align: 'start', sortable: false, width: '150px', class: 'blue lighten-5' },
  ...days.map(day => ({
      text: day.text,
      value: day.key,
      align: 'center',
      sortable: false,
      width: '10%'
  }))
];

const HOUR_SLOTS = [
  { id: 5,  label: "05:00" },
  { id: 6,  label: "06:00" },
  { id: 7,  label: "07:00" },
  { id: 8,  label: "08:00" },
  { id: 9,  label: "09:00" },
  { id: 10, label: "10:00" },
  { id: 11, label: "11:00" },
  { id: 12, label: "12:00" },
  { id: 13, label: "13:00" },
  { id: 14, label: "14:00" },
  { id: 15, label: "15:00" },
  { id: 16, label: "16:00" },
  { id: 17, label: "17:00" },
  { id: 18, label: "18:00" },
  { id: 19, label: "19:00" },
  { id: 20, label: "20:00" },
  { id: 21, label: "21:00" },
  { id: 22, label: "22:00" },
  { id: 23, label: "23:00" },
];

const generateNext4MonthsDates = () => {
  const dates = [];
  const today = new Date();
  const startDate = new Date(today.getFullYear(), today.getMonth(), 1);
  const endDate = new Date(today.getFullYear(), today.getMonth() + 4, 1);
  let currentDate = new Date(startDate);

  while (currentDate < endDate) {
    dates.push(new Date(currentDate));
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return dates;
};

const parseRawPatternObject = (rawPatternObject) => {
  const initialCodes = Array.from(
    { length: HOUR_SLOTS.length },
    () => Array(7).fill(null)
  );

  if (!rawPatternObject) return initialCodes;

  Object.entries(DAY_KEY_MAP_INVERSE).forEach(([dayIndexStr, mysqlKey]) => {
    const dayIndex = Number(dayIndexStr);
    const patternString = rawPatternObject[mysqlKey];

    if (!patternString || typeof patternString !== "string") return;

    const values = patternString.split(',').map(s => s.trim());

    values.slice(0, HOUR_SLOTS.length).forEach((val, hourIndex) => {

      const parts = val.split(':');
      const codeString = parts.length === 2 ? parts[1].trim() : val.trim();

      if (codeString === "null" || codeString === "") {
        initialCodes[hourIndex][dayIndex] = null;
      } else {
        const code = Number(codeString);
        initialCodes[hourIndex][dayIndex] = isNaN(code) ? null : code;
      }
    });
  });

  return initialCodes;
};

export default {
  name: 'ProAppointmentsAPage',
  components: {
      MainHeaderPlatA,
      MainHeaderPlatB,
      VOverlayLoader,
      VSnackBar,
  },
  data: () => ({
    today: new Date().toLocaleDateString('sv-SE'),
    focus: new Date().toLocaleDateString('sv-SE'),
    type: 'month',
    typeToLabel: {
      month: 'Mes',
      week: 'Semana',
      day: 'Dia',
      '4day': '4 Dias',
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1', 'brown darken-4', 'red darken-1', 'lime darken-4'],
    name: null,
    color: '#eff2f4',
    details: null,
    nPat: '',
    patientNameAbrev: '',
    start: null,
    end: null,
    observations: '',
    dialog: false,
    dialogVerif: false,
    dialogDel: false,
    loading: false,
    otp: '',
    text: '',
    currentlyEditing: null,
    patternCheckboxAll: false,
    patternCheckboxPR: false,
    patternCheckboxON: false,
    patternCheckboxAD: false,
    local1AllCheckbox: false,
    local1C1Checkbox: false,
    local1C2Checkbox: false,
    local1C3Checkbox: false,
    local1C4Checkbox: false,
    local2AllCheckbox: false,
    local2C2Checkbox: false,
    local2C3Checkbox: false,
    local2C4Checkbox: false,
    headers,
    days,
    availabilityHours: generateHours(), 
    loadedWeeklyPattern: [], 
    isLoadingInitial: true,
    localStatus: "",
    filteredEventsAll: [],
    filteredEventsPR: [],
    filteredEventsON: [],
    filteredEventsAD: [],
    filteredEventsPatternAll: [],
    filteredEventsPatternPR: [],
    filteredEventsPatternON: [],
    filteredEventsPatternAD: [],
    showModal: false,
    generatedText: "",
    copyButtonText: "Copiar"
  }),

  async mounted() {
    this.isLoadingInitial = true;

    const token = getToken() || localStorage.getItem('token');
    if (!token) {
      console.warn("No hay token. Claves actuales en storage:", Object.keys(localStorage));
      this.isLoadingInitial = false;
      return;
    }

    try {
      await this.loadSchema();
      
      if (!this.events || this.events.length === 0) {
        await this.loadEvents(this.focus);
      }
    } catch (error) {
      console.error("Error crítico:", error);
    } finally {
      this.isLoadingInitial = false;
    }
  },

  computed: {
    ...mapGetters('proAppointmentsAPage', ['schema', 'catEventType', 'events', 'dataWeeklyPattern', 'localsEvents', 'status', 'dataNamePatient']),
    ...mapGetters('notifications', ['snackbar']),

    effectiveStatus() {
      if (this.isLoadingInitial) return 'loading';
      return this.status;
    },

    isSessionOrBusy() {
      return ['Sesión', 'Ocupado'].some(t => this.name?.includes(t));
    },

    activityLegend() {
      return this.catEventType || [];
    },
    
    patternEvents() {

      // 1. Validaciones
      if (!this.loadedWeeklyPattern || this.loadedWeeklyPattern.flat().every(v => v === null)) { return []; }
      if (!this.catEventType || this.catEventType.length === 0) return [];

      const dates = generateNext4MonthsDates();
      const eventsPattern = [];

      // Función para convertir a formato local (igual que ev.start)
      const formatLocal = (d) => {
        const pad = (n) => String(n).padStart(2, "0");
        return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
      };

      dates.forEach(date => {
        const dayIndex = date.getDay();
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();

        this.loadedWeeklyPattern.forEach((hourCodes, hourIndex) => {

          const slot = HOUR_SLOTS[hourIndex];
          if (!slot) return;

          const activityCode = hourCodes[dayIndex] ?? 0;
          if (activityCode === 0) return;

          const activity = this.catEventType.find(a => a.event_type_id == activityCode);
          if (!activity) return;

          const startDate = new Date(year, month, day, slot.id, 0);
          const endDate   = new Date(year, month, day, slot.id + 1, 0);

          const startLocal = formatLocal(startDate);

          // FILTRO: evitar choques exactos con eventos reales
          const normalizeDate = (str) => {
            if (!str) return null;
            const d = new Date(str.replace(" ", "T")); 
            if (isNaN(d)) return null;
            const pad = (n) => String(n).padStart(2, "0");
            return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
          };

          const existsRealEvent = this.events?.some(ev => {
            return normalizeDate(ev.start) === normalizeDate(startLocal);
          });

          if (existsRealEvent) return;

          const COLOR_MAP = {
            "Ocupado": "grey darken-1",
            "Ocupado Presencial": "brown darken-4",
            "Ocupado Online": "grey darken-1",
            "Ocupado a Domicilio": "grey darken-1",
            "Académico": "cyan",
            "Laboral": "deep-purple",
            "Personal": "lime darken-4",
            "Viaje": "orange",
            "Feriado": "red darken-1",
            "Otros": "lime darken-4",
          };

          const colorCond = activity.event_type.includes("Sesión")
            ? "green"
            : COLOR_MAP[activity.event_type] || "black";

          eventsPattern.push({
            name: activity.event_type,
            start: startLocal,
            end: formatLocal(endDate),
            color: colorCond,
            timed: true,
            activityId: activityCode,
            isPattern: true,
          });
        });
      });

      return eventsPattern;
    },

    typeEventGroup() {
      return this.catEventType.map(t => t.event_type);
    },

    typeEventAbbrev() {
      return this.catEventType;
    },

    title() {
      const { start, end } = this;
      if (!start || !end) {
        return '';
      }

      const startMonth = this.monthFormatter(start);
      const endMonth = this.monthFormatter(end);
      const suffixMonth = startMonth === endMonth ? '' : endMonth;

      const startYear = start.year;
      const endYear = end.year;
      const suffixYear = startYear === endYear ? '' : endYear;

      const startDay = start.day + this.nth(start.day);
      const endDay = end.day + this.nth(end.day);

      switch (this.type) {
        case 'month':
          return `${startMonth} ${startYear}`;
        case 'week':
        case '4day':
          return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`;
        case 'day':
          return `${startMonth} ${startDay} ${startYear}`;
      }
      return '';
    },

    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: 'UTC',
        month: 'long',
      });
    },

    filteredLocals() {
      if (!this.localsEvents || this.localsEvents.length === 0) return [];

      // 1. Mapeo de la configuración de salas con el estado actual de los checkboxes
      const roomMap = [
        { key: "C1", alias: "C1", checked: this.local1C1Checkbox },
        { key: "C2", alias: "C2", checked: this.local1C2Checkbox },
        { key: "C3", alias: "C3", checked: this.local1C3Checkbox },
        { key: "C4", alias: "C4", checked: this.local1C4Checkbox },
      ];

      // Paso A: Transformar y marcar para eliminación (null)
      const processedEvents = this.localsEvents.map(event => {
        // Si el evento no es "Consultorios", lo mantenemos sin filtrar (o ajusta esta lógica si es necesario)
        if (event.name !== "Consultorios") {
          return event;
        }

        const match = (event.details || "").match(/^(Local\d+):\s*(.*)$/);

        let prefix = "";
        let rawDetails = event.details || "";

        if (match) {
          prefix = match[1];
          rawDetails = match[2];
        }

        const eventAliases = rawDetails
          .split(" , ")
          .map(s => s.trim())
          .filter(s => s.length > 0);

        // Filtrar los alias de la lista basándose en los checkboxes activos
        const visibleAliases = eventAliases.filter(alias => {
          // Encontrar la configuración de sala que coincide con este alias
          const roomConfig = roomMap.find(room => room.alias === alias);
          
          // La sala es visible SÓLO si su checkbox correspondiente está activo
          return roomConfig && roomConfig.checked;
        });

        if (visibleAliases.length === 0) {
          return null; 
        }

        return {
          ...event,
          details: prefix
            ? `${prefix}: ${visibleAliases.join(" , ")}`
            : visibleAliases.join(" , "),
          name: "Consultorios",
        };
      });

      // Paso B: Eliminar todos los eventos que resultaron en 'null' (sin salas activas)
      return processedEvents.filter(event => event !== null);
    },

    filteredAvailabilityPattern() {
      if (!this.patternEvents || this.patternEvents.length === 0) return [];

      const normalize = (str) =>
        str?.toLowerCase()
          ?.normalize("NFD")
          ?.replace(/[\u0300-\u036f]/g, "")
          ?.trim() ?? "";

      // Construimos la lista de tipos seleccionados
      const selectedTypes = [];

      if (this.patternCheckboxPR) selectedTypes.push("sesion presencial");
      if (this.patternCheckboxON) selectedTypes.push("sesion online");
      if (this.patternCheckboxAD) selectedTypes.push("sesion a domicilio");

      // Si está activo "All", devolver TODO lo que es sesión
      if (this.patternCheckboxAll || selectedTypes.length === 0) {
        return this.patternEvents.filter(event =>
          normalize(event.name).includes("sesion")
        );
      }

      // Filtrado según múltiples checkboxes activos
      return this.patternEvents.filter(event => {
        const name = normalize(event.name);

        return selectedTypes.some(type => name.includes(type));
      });
    },

    filteredNoAvailabilityPattern() {
      if (!this.patternEvents || this.patternEvents.length === 0) return [];

      return this.patternEvents.filter(event => {
        // Condición 1: Comprobar que el nombre contenga "Sesión"
        const nameNoContainsSession = event.name 
          && typeof event.name === 'string' 
          && !event.name.toLowerCase().includes('sesión');

        // Condición 2: Comprobar que isPattern sea true
        const isPatternEvent = event.isPattern === true;

        return nameNoContainsSession && isPatternEvent;
      });
    },

    filteredAvailability() {
      if (!this.events || this.events.length === 0) return [];

      const normalize = (str) =>
        str?.toLowerCase()
          ?.normalize("NFD")
          ?.replace(/[\u0300-\u036f]/g, "")
          ?.trim() ?? "";

      // Construimos la lista de tipos seleccionados
      const selectedTypes = [];
      if (this.patternCheckboxPR) selectedTypes.push("sesion presencial");
      if (this.patternCheckboxON) selectedTypes.push("sesion online");
      if (this.patternCheckboxAD) selectedTypes.push("sesion a domicilio");

      return this.events.filter(event => {
        const name = normalize(event.name);
        const details = normalize(event.details);

        // Debe ser una sesión
        const nameContainsSession = name.includes("sesion");

        // Debe ser "Disponible" en details
        const detailsContainsAvailability = details.includes("disponible");

        // Si no es sesión disponible, lo descartamos
        if (!(nameContainsSession && detailsContainsAvailability)) return false;

        // Si "All" está marcado o no hay tipos seleccionados, devolvemos todas las sesiones disponibles
        if (this.patternCheckboxAll || selectedTypes.length === 0) return true;

        // Si hay tipos seleccionados (PR/ON/AD), devolvemos sólo si el nombre coincide con alguno
        return selectedTypes.some(type => name.includes(type));
      });
    },

    allCombinedAndFilteredEvents() {
      let eventsBD = this.events;
      let sessionAvailability = [];
      let sessionAvailabilityPattern = [];
      let sessionNoAvailabilityPattern = [];
      let sessionEventsLocals = this.filteredLocals;

      // --- FILTRO DEL PATRÓN SEGÚN CHECKBOXES ---
      if (this.patternCheckboxAll || this.patternCheckboxPR || this.patternCheckboxON || this.patternCheckboxAD) {
        eventsBD = [];
        sessionAvailability = this.filteredAvailability;
        sessionAvailabilityPattern = this.filteredAvailabilityPattern;
      } else {
        sessionAvailabilityPattern = this.filteredNoAvailabilityPattern;
        sessionNoAvailabilityPattern = [];
      }

      return [
        ...eventsBD,
        ...sessionAvailability,
        ...sessionAvailabilityPattern,
        ...sessionNoAvailabilityPattern,
        ...sessionEventsLocals,
      ];
    }
  },

  watch: {
    name(newVal) {
      if (!newVal) return;
      
      const COLOR_MAP = {
        "Sesión": "green",
        "Sesión Presencial": "green",
        "Sesión Online": "green",
        "Sesión a Domicilio": "green",
        "Ocupado": "grey darken-1",
        "Ocupado Presencial": "grey darken-1",
        "Ocupado Online": "grey darken-1",
        "Ocupado a Domicilio": "grey darken-1",
        "Laboral": "deep-purple",
        "Académico": "cyan",
        "Personal": "brown darken-4",
        "Viaje": "orange",
        "Feriado": "red darken-1",
        "Otros": "lime darken-4",
      };

      if (COLOR_MAP[newVal]) {
        this.color = COLOR_MAP[newVal];
      }
    },

    dataWeeklyPattern: {
      handler(newVal) {
        if (!newVal) return;
        const initialCodes = parseRawPatternObject(newVal);
        this.loadedWeeklyPattern = JSON.parse(JSON.stringify(initialCodes));
        this.availabilityHours = generateHours(initialCodes);
      },
      immediate: true,
      deep: true
    },

    catEventType: {
      handler(val) {
        if (val && val.length > 0) {
          this.$forceUpdate();
        }
      },
      immediate: true
    },

    loadedWeeklyPattern: {
      handler() {
        this.$forceUpdate();
      },
      deep: true
    },

    patternCheckboxAll(newVal) {
      ['patternCheckboxPR','patternCheckboxON','patternCheckboxAD']
        .forEach(key => this[key] = newVal);
    },

    patternCheckboxPR() { this.updatePatternAll(); this.applyFilterAvailPR(); },
    patternCheckboxON() { this.updatePatternAll(); this.applyFilterAvailON(); },
    patternCheckboxAD() { this.updatePatternAll(); this.applyFilterAvailAD(); },

    local1AllCheckbox(newVal) {
      ['local1C1Checkbox','local1C2Checkbox','local1C3Checkbox','local1C4Checkbox']
        .forEach(key => this[key] = newVal);
    },

    local1C1Checkbox() { this.updatelocal1All(); },
    local1C2Checkbox() { this.updatelocal1All(); },
    local1C3Checkbox() { this.updatelocal1All(); },
    local1C4Checkbox() { this.updatelocal1All(); },

    local2AllCheckbox(newVal) {
      ['local2C2Checkbox','local2C3Checkbox','local2C4Checkbox']
        .forEach(key => this[key] = newVal);
    },

    local2C2Checkbox() { this.updatelocal2All(); },
    local2C3Checkbox() { this.updatelocal2All(); },
    local2C4Checkbox() { this.updatelocal2All(); },
  },

  methods: {
    ...mapActions('proAppointmentsAPage', [
      'loadSchema',
      'loadEvents',
      'updateEvents',
      'delEvents',
      'verifPat',
      'updateWeeklyPattern',
    ]),
    ...mapActions('notifications', ['triggerSnackbar']),

    getActivity(id) {
      return this.catEventType.find(a => a.id === id) || this.catEventType[0];
    },

    getActivityAbbr(id) {
      return this.getActivity(id).event_type_abbrev;
    },
    
    saveAvailability() {
      const patternPayload = {};
      const dayKeys = Object.values(DAY_KEY_MAP_INVERSE);

      const HOURS_ORDER = [...Array(24).keys()];

      dayKeys.forEach((dayKey, dayIndex) => {
        const daySlots = [];

        HOURS_ORDER.forEach((hour) => {
          const realIndex = hour;

          const rawId = this.availabilityHours[realIndex]?.availability[dayIndex];
          const id = rawId == null ? 0 : rawId;

          daySlots.push(`${hour}:${id}`);
        });

        patternPayload[dayKey] = daySlots.join(', ');
      });

      this.updateWeeklyPattern(patternPayload)
        .then(() => {
          this.triggerSnackbar({
            visible: true,
            content: this.schema.snackOk,
            color: "success"
          });
          this.getEvents()
        })
        .catch(() => {
          this.triggerSnackbar({
            visible: true,
            content: "Error al guardar el patrón semanal de disponibilidad.",
            color: "error"
          });
        });
    },
    
    // Función para reiniciar la disponibilidad a 'No Definido' (código 0)
    resetAvailability() {
      this.availabilityHours = this.availabilityHours.map(item => ({
        ...item,
        availability: Array(7).fill(0),
      }));
      this.triggerSnackbar({
        visible: true,
        content: "Patrón de disponibilidad reiniciado a 'No Definido'.",
        color: "warning"
      });
    },

    buildPatternObject() {
      const pattern = {
        weekly_pattern_monday: "",
        weekly_pattern_tuesday: "",
        weekly_pattern_wednesday: "",
        weekly_pattern_thursday: "",
        weekly_pattern_friday: "",
        weekly_pattern_saturday: "",
        weekly_pattern_sunday: "",
      };

      this.days.forEach((day, index) => {
        const column = this.availabilityHours.map(row => row.availability[index]);
        pattern[`weekly_pattern_${day.key}`] = column.join(", ");
      });

      return pattern;
    },
    
    async cleanForm() {
      this.name = '';
      this.color = '#eff2f4';
      this.details = '';
      this.nPat = '';
      this.patientNameAbrev = '';
      this.start = '';
      this.end = '';
      this.observations = '';
    },

    async onFinish() {
      this.loading = true;

      let model = {};
      if (this.nPat === '' || this.nPat === null) {
        model.nPat = this.selectedEvent.nPat;
      } else {
        model.nPat = this.nPat;
      }
      model.otp = this.otp;

      this.$store.dispatch('proAppointmentsAPage/verifPat', { model }).then(
        () => {
          if (this.status === true) {
            setTimeout(() => {
              this.loading = false;
              this.text = 'PIN de Usuario es correcto';
            }, 500);
            this.otp = '';
            this.text = '';

            if (this.dataNamePatient) {
              if (this.nPat === '' || this.nPat === null) {
                this.selectedEvent.patientNameAbrev = this.dataNamePatient;
              } else {
                this.patientNameAbrev = this.dataNamePatient;
              }
            } else {
              if (this.nPat === '' || this.nPat === null) {
                this.selectedEvent.patientNameAbrev = '';
              } else {
                this.patientNameAbrev = '';
              }
              this.snackbar.visible = false;
              this.snackbar.visible = true;
              this.snackbar.content = this.schema.snackNoPatient;
            }
            this.dialogVerif = false;
          } else if (this.status === false) {
            setTimeout(() => {
              this.loading = false;
              this.text = 'PIN de Usuario es incorrecto';
            }, 500);
          }
        },
        () => {
          setTimeout(() => {
            this.loading = false;
            this.text = 'PIN de Usuario es incorrecto';
            this.patientNameAbrev = '';
          }, 500);
        }
      );
      this.otp = '';
      this.text = ' ';
    },

    async cleanName() {
      this.patientNameAbrev = '';
    },

    onNPatInput() {
      this.selectedEvent.patientNameAbrev = null;
    },

    async updateEvent(ev) {
      if (ev.calendar_events_id === null || ev.isPattern === true) {
        try {
          const normalizeDate = (str) => str.replace(" ", "T");

          const isIsoDatetime = (str) => {
              return typeof str === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(str);
          };

          if (ev.name && isIsoDatetime(normalizeDate(ev.start)) && isIsoDatetime(normalizeDate(ev.end))) {
            let model = {
              name: ev.name,
              color: ev.color,
              details: ev.details,
              nPat: ev.nPat,
              start: ev.start,
              end: ev.end,
              observations: ev.observations,
            };
            this.patientNameAbrev = '';

            this.$store.dispatch('proAppointmentsAPage/saveEvents', model).then(
              () => {
                if (this.status === 'loaded') {
                  this.snackbar.visible = false;
                  this.snackbar.visible = true;
                  this.snackbar.content = this.schema.snackOk;
                  this.getEvents();
                  this.name = null;
                  this.color = null;
                  this.details = null;
                  this.nPat = null;
                  this.start = null;
                  this.end = null;
                  this.observations = null;
                } else if (this.status === 'error') {
                  this.snackbar.visible = false;
                  this.snackbar.visible = true;
                  this.snackbar.content = this.schema.snackError;
                  this.getEvents();
                  this.name = null;
                  this.color = null;
                  this.details = null;
                  this.nPat = null;
                  this.start = null;
                  this.end = null;
                  this.observations = null;
                }
              },
              () => {
                this.snackbar.visible = false;
                this.snackbar.visible = true;
                this.snackbar.content = this.schema.snackError;
                this.getEvents();
                this.name = null;
                this.color = null;
                this.details = null;
                this.nPat = null;
                this.start = null;
                this.end = null;
                this.observations = null;
              }
            );
          } else {
            this.snackbar.visible = false;
            this.snackbar.visible = true;
            this.snackbar.content = this.schema.snackEmpties;
          }
        } catch (error) {
          console.error('[App Error]:', error.message || 'Error actualizando evento')
          throw error;
        }
      } else {
        try {
          const id = ev.calendar_events_id;

          let model = {};
          model = this.selectedEvent;

          this.$store.dispatch('proAppointmentsAPage/updateEvents', { id, model }).then(
            () => {
              if (this.status === 'loaded') {
                this.snackbar.visible = false;
                this.snackbar.visible = true;
                this.snackbar.content = this.schema.snackOk;
                this.getEvents();
              } else if (this.status === 'error') {
                this.snackbar.visible = false;
                this.snackbar.visible = true;
                this.snackbar.content = this.schema.snackError;
                this.getEvents();
              }
            },
            () => {
              this.snackbar.visible = false;
              this.snackbar.visible = true;
              this.snackbar.content = this.schema.snackError;
              this.getEvents();
            }
          );
          this.selectedOpen = false;
          this.currentlyEditing = null;
        } catch (error) {
          console.error('[App Error]:', error.message || 'Error actualizando evento');
          throw error;
        }
      }          
    },

    editEvent(id) {
      this.currentlyEditing = id;
    },

    async deleteEvent(ev) {
      try {
        const id = ev.calendar_events_id;
        this.$store.dispatch('proAppointmentsAPage/delEvents', { id }).then(
          () => {
            if (this.status === 'loaded') {
              this.snackbar.visible = false;
              this.snackbar.visible = true;
              this.snackbar.content = this.schema.snackOkRemoved;
              this.getEvents();
            } else if (this.status === 'errorNotID') {
              this.snackbar.visible = false;
              this.snackbar.visible = true;
              this.snackbar.content = "Este evento es de la plantilla, se elimina desde ese sector.";
              this.getEvents();
            } else if (this.status === 'error') {
              this.snackbar.visible = false;
              this.snackbar.visible = true;
              this.snackbar.content = this.schema.snackDelError;
              this.getEvents();
            }
          },
          () => {
            this.snackbar.visible = false;
            this.snackbar.visible = true;
            this.snackbar.content = this.schema.snackDelError;
            this.getEvents();
          }
        );
        this.selectedOpen = false;
        this.getEvents();
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error eliminando evento');
        throw error;
      }
    },

    async addEvent() {
      try {
        this.patientNameAbrev = '';

        const isIsoDatetime = (str) => {
          return typeof str === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(str);
        };

        if (this.name && isIsoDatetime(this.start) && isIsoDatetime(this.end)) {
          let model = {
            name: this.name,
            color: this.color,
            details: this.details,
            nPat: this.nPat,
            start: this.start,
            end: this.end,
            observations: this.observations,
          };
          this.patientNameAbrev = '';

          this.$store.dispatch('proAppointmentsAPage/saveEvents', model).then(
            async () => {
              if (this.status === 'loaded' || this.status === 'success') {
                this.snackbar.visible = false;
                this.snackbar.visible = true;
                this.snackbar.content = this.schema.snackOk;
                
                await this.getEvents();
                this.$forceUpdate();

                this.name = null;
                this.color = '#eff2f4';
                this.details = null;
                this.nPat = null;
                this.start = null;
                this.end = null;
                this.observations = null;
              } else {
                this.snackbar.visible = false;
                this.snackbar.visible = true;
                this.snackbar.content = this.schema.snackError;
              }
            },
            () => {
              this.snackbar.visible = false;
              this.snackbar.visible = true;
              this.snackbar.content = this.schema.snackError;
            }
          );
        } else {
          this.snackbar.visible = false;
          this.snackbar.visible = true;
          this.snackbar.content = this.schema.snackEmpties;
        }
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },

    async getEvents() {
      this.patientNameAbrev = '';

      const dateFocus = this.focus;
      await this.$store.dispatch('proAppointmentsAPage/loadEvents', dateFocus);
    },

    viewDay({ date }) {
      this.focus = date;
      this.type = 'day';
    },

    getEventColor(event) {
      return event.color;
    },

    setToday() {
      this.focus = this.today;
    },

    prev() {
      this.$refs.calendar.prev();
    },

    next() {
      this.$refs.calendar.next();
    },

    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() => requestAnimationFrame(() => (this.selectedOpen = true)));
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },

    updateRange({ start, end }) {
      const toDatetimeLocal = (date) => {
        const pad = (n) => String(n).padStart(2, '0');
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
      };

      this.start = start instanceof Date && !isNaN(start) ? toDatetimeLocal(start) : '';
      this.end = end instanceof Date && !isNaN(end) ? toDatetimeLocal(end) : '';
    },

    parseDetails(details = "") {
      return details
        .split(",")
        .map(r => r.trim().toUpperCase())
        .filter(Boolean);
    },

    applyFilterAvailAll() {
      this.filteredEventsAll = this.filteredAvailability;
      this.filteredEventsPatternAll = this.filteredAvailabilityPattern;
    },

    applyFilterAvailPR() {
      this.filteredEventsPR = this.filteredAvailability;
      this.filteredEventsPatternPR = this.filteredAvailabilityPattern;
    },

    applyFilterAvailON() {
      this.filteredEventsON = this.filteredAvailability;
      this.filteredEventsPatternON = this.filteredAvailabilityPattern;
    },

    applyFilterAvailAD() {
      this.filteredEventsAD = this.filteredAvailability;
      this.filteredEventsPatternAD = this.filteredAvailabilityPattern;
    },

    updatePatternAll() {
      const all = this.patternCheckboxPR && this.patternCheckboxON &&
                  this.patternCheckboxAD;
      if (this.patternCheckboxAll !== all) {
        this.patternCheckboxAll = all;
      }
    },

    updatelocal1All() {
      const all = this.local1C1Checkbox && this.local1C2Checkbox &&
                  this.local1C3Checkbox && this.local1C4Checkbox;
      if (this.local1AllCheckbox !== all) {
        this.local1AllCheckbox = all;
      }
    },

    updatelocal2All() {
      const all = this.local2C2Checkbox &&
                  this.local2C3Checkbox && this.local2C4Checkbox;
      if (this.local2AllCheckbox !== all) {
        this.local2AllCheckbox = all;
      }
    },

    generateAvailabilityText() {
      const regularEvents = this.events || []; 
      const patternEvents = this.weekPatternEvents || this.patternEvents || []; 
      const localsEvents = this.localsEvents || this.filteredLocals || []; 

      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      const end = new Date(today);
      const daysUntilSunday = 7 - today.getDay();
      end.setDate(today.getDate() + daysUntilSunday + 6); 
      end.setHours(23, 59, 59, 999);

      const normalizeDate = (val) => {
        if (!val) return new Date(NaN);
        const d = new Date(typeof val === 'string' ? val.replace(" ", "T") : val);
        d.setSeconds(0, 0);
        d.setMilliseconds(0);
        return d;
      };

      const normalizeName = (str) =>
        str?.toLowerCase()
          ?.normalize("NFD")
          ?.replace(/[\u0300-\u036f]/g, "")
          ?.trim() ?? "";

      const DAYS = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];

      const occupiedTimes = new Set();
      const availabilityNames = [
        "sesión", "sesion", "se",
        "sesión presencial", "sesion presencial", "sp", 
        "sesión online", "sesion online", "so", 
        "sesión a domicilio", "sesion a domicilio", "sd",
        "disponible"
      ];
      
      regularEvents.forEach(ev => {
        const name = normalizeName(ev.name);
        const isConsultorio = name.includes("consultorio") || name.match(/c[1-4]/);
        const isAvail = availabilityNames.some(an => name.includes(an)) && !name.includes("ocupado");
        
        if (!isAvail && !isConsultorio) {
          const d = normalizeDate(ev.start);
          if (!isNaN(d)) occupiedTimes.add(d.getTime());
        }
      });

      const availableConsultorios = new Set();
      localsEvents.forEach((ev) => {
        const name = normalizeName(ev.name);
        if (name.includes("consultorio") || name.match(/c[1-4]/)) {
          const d = normalizeDate(ev.start);
          if (!isNaN(d)) availableConsultorios.add(d.getTime());
        }
      });

      const combinedEvents = [...regularEvents, ...patternEvents];

      const grouped = {
        "Presencial": {},
        "Online": {},
        "A Domicilio": {}
      };

      combinedEvents.forEach((ev) => {
        const d = normalizeDate(ev.start);
        
        if (isNaN(d) || d < today || d > end) return; 

        const timestamp = d.getTime();
        
        if (occupiedTimes.has(timestamp)) return;

        const dayKey = `${DAYS[d.getDay()]} ${String(d.getDate()).padStart(2, "0")}`;
        const name = normalizeName(ev.name);

        if (name.includes("ocupado")) return;

        const isPresencial = name.includes("presencial") || name === "sp";
        const isOnline = name.includes("online") || name === "so";
        const isDomicilio = name.includes("domicilio") || name === "sd";
        const isGenerica = (name.includes("sesion") || name === "se" || name.includes("disponible")) && !isPresencial && !isOnline && !isDomicilio;

        if (isPresencial) {
          if (availableConsultorios.has(timestamp)) {
            if (!grouped["Presencial"][dayKey]) grouped["Presencial"][dayKey] = [];
            grouped["Presencial"][dayKey].push(d);
          }
        } 
        else if (isOnline) {
          if (!grouped["Online"][dayKey]) grouped["Online"][dayKey] = [];
          grouped["Online"][dayKey].push(d);
        } 
        else if (isDomicilio) {
          if (!grouped["A Domicilio"][dayKey]) grouped["A Domicilio"][dayKey] = [];
          grouped["A Domicilio"][dayKey].push(d);
        }
        else if (isGenerica) {
          if (!grouped["Online"][dayKey]) grouped["Online"][dayKey] = [];
          grouped["Online"][dayKey].push(d);

          if (!grouped["A Domicilio"][dayKey]) grouped["A Domicilio"][dayKey] = [];
          grouped["A Domicilio"][dayKey].push(d);

          if (availableConsultorios.has(timestamp)) {
            if (!grouped["Presencial"][dayKey]) grouped["Presencial"][dayKey] = [];
            grouped["Presencial"][dayKey].push(d);
          }
        }
      });

      let finalString = "";
      let hasAvailability = false;

      const categories = [
        { key: "Presencial", label: "Presencial" },
        { key: "Online", label: "Online" },
        { key: "A Domicilio", label: "A Domicilio" }
      ];

      categories.forEach(cat => {
        const daysInCat = Object.keys(grouped[cat.key]);
        if (daysInCat.length === 0) return;

        if (!hasAvailability) {
          finalString += "Correcto, esta es la disponibilidad:\n\n";
          hasAvailability = true;
        }

        finalString += `${cat.label}:\n`;
        
        const sortedDays = daysInCat.sort((a, b) => {
          return grouped[cat.key][a][0].getTime() - grouped[cat.key][b][0].getTime();
        });

        sortedDays.forEach(day => {
          const datesArray = grouped[cat.key][day];
          datesArray.sort((a, b) => a.getTime() - b.getTime());
          
          const amHours = [];
          const pmHours = [];
          const seenHours = new Set(); 

          datesArray.forEach(d => {
            let h = d.getHours();
            const isPm = h >= 12;
            const ampm = isPm ? "pm" : "am";
            
            h = h % 12 || 12; 
            
            const uniqueKey = `${h}${ampm}`;
            if (!seenHours.has(uniqueKey)) {
              seenHours.add(uniqueKey);
              if (isPm) {
                pmHours.push(h);
              } else {
                amHours.push(h);
              }
            }
          });

          let timeBlocks = [];
          if (amHours.length > 0) {
            timeBlocks.push(`${amHours.join(" / ")} am`);
          }
          if (pmHours.length > 0) {
            timeBlocks.push(`${pmHours.join(" / ")} pm`);
          }

          const formattedHours = timeBlocks.join("   |||   ");
          
          finalString += ` • ${day}:   ${formattedHours}\n`;
        });
        
        finalString += "\n";
      });

      return finalString.trim() === "" ? "No hay horarios disponibles para mostrar." : finalString.trim();
    },

    openAvailabilityModal() {
      try {
        this.generatedText = this.generateAvailabilityText();
        this.copyButtonText = "Copiar";
        this.showModal = true;
      } catch (error) {
        console.error("Error al generar el texto:", error);
      }
    },

    async copyText() {
      try {
        await navigator.clipboard.writeText(this.generatedText);
        this.copyButtonText = "¡Copiado!";
        setTimeout(() => {
          this.copyButtonText = "Copiar";
        }, 2000);
      } catch (err) {
        console.error("Error copying text: ", err);
        alert("Hubo un error al intentar copiar el texto.");
      }
    }
  },
};
</script>
